import { Storage } from '@ionic/storage';
import { Observable, from, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthServiceProvider } from './users/auth-service/auth-service';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { LoadingController, ToastController } from '@ionic/angular';
import { mergeMap, retry, map, catchError, tap, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserProfileStorageService } from './services/user-profile-storage.service';
import { SimpleIndexedDBService } from './services/simple-indexeddb.service';

@Injectable({
  providedIn: 'root',
})

export class HttpRequestInterceptorService implements HttpInterceptor {
  indicator: HTMLIonLoadingElement = null;
  requestsQueue: Array<any> = [];
  errorShowing = false;
  selectedAgency = 0;

  constructor(
    private loading: LoadingController,
    private toastController: ToastController,
    private indexedDB: SimpleIndexedDBService,
    private router: Router,
    private authService: AuthServiceProvider,
    private userProfileStorage: UserProfileStorageService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tokenPromise = this.indexedDB.getItem('idToken');

    // Get profile data from centralized service
    const profile = this.userProfileStorage.profile;
    const selectedAgency = profile && profile.selectedAgencyId;
    const secondaryToken = profile && profile.secondaryToken;

    const tokenObservable = from(tokenPromise);

    return tokenObservable.pipe(
      mergeMap((token: string) => {
        if (token === undefined || token === null || token === '') {
          this.indexedDB.clear();
          this.userProfileStorage.clearProfile();
          // Use setTimeout to prevent blocking the current execution
          setTimeout(() => {
            this.authService.signOut();
          }, 100);
          return throwError('Token not available');
        }

        if (this.tokenExpired(token)) {
          this.indexedDB.clear();
          this.userProfileStorage.clearProfile();
          // Use setTimeout to prevent blocking the current execution
          setTimeout(() => {
            this.authService.signOut();
          }, 100);
          return throwError('Token expired');
        }

        const customHeaders = {};

        if (token) {
          customHeaders['Authorization'] = `Bearer ${token}`;
        }

        if (selectedAgency) {
          customHeaders['X-Agency'] = selectedAgency;
        }
        
        if (secondaryToken) {
          customHeaders['SecondaryToken'] = secondaryToken;
        }

        //customHeaders['Content-Type'] = 'application/json';

        const authorizedRequest = req.clone({
          headers: new HttpHeaders(customHeaders),
        });

        return next.handle(authorizedRequest).pipe(
          map(event => {
            if (event instanceof HttpErrorResponse || event instanceof HttpResponse) {
              console.log(event)
            }
            return event;
          }),
          catchError((err, caugth) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status == 401) {

              } // do the magic
            }
            return throwError(err);
          }),
          finalize(() => {
            console.log('')
          }));
      })
    );
  }

  private tokenExpired(token: string) {
    try {
      if (!token || token.split('.').length !== 3) {
        return true;
      }
      const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
      var currenttime = (Math.floor((new Date).getTime() / 1000))
      return currenttime >= expiry;
    } catch (error) {
      console.error('Error checking token expiry:', error);
      return true; // Treat as expired if we can't parse it
    }
  }

  async showError() {
    if (!this.errorShowing) {
      this.errorShowing = true;
      this.toastController
        .create({
          message: 'Unable to complete your request.',
          cssClass: 'toast-danger',
          duration: 4000,
        })
        .then((toast) => {
          toast.present();
          toast.onDidDismiss().then(() => {
            this.errorShowing = false;
          });
        });
    }
  }

  showLoader() {
    if (this.indicator == null) {
      this.indicator = {} as HTMLIonLoadingElement;
      if (this.requestsQueue.length == 0) {
        this.loading
          .create({
            message: 'Please wait...',
            duration: 5000,
          })
          .then((res) => {
            this.indicator = res;
            res.present();

            // res.onDidDismiss().then((dis) => {
            // console.log("Loading dismissed!");
            // });
          });
      }
    }
    // this.requestsQueue.push({});
  }

  hideLoader() {
    this.requestsQueue.pop();
    if (this.requestsQueue.length == 0) {
      if (this.indicator != null || this.indicator != undefined) {
        if (this.indicator.dismiss) { this.indicator.dismiss(); }
      }
      this.indicator = null;
    }
  }
}
